export default {
    ZeroPercent: 0,
    OnePercent: 1,
    TwoPercent: 2,
    ThreePercent: 3,
    FivePercent: 5,
};
